import Avatar from "@/components/base/Avatar";
import type { RpsJoin } from "@/lib/types";
import { handEmoji, handFull, resultBadge, resultLabel } from "../utils";

interface Props {
  joins: RpsJoin[];
}

// 마감된 판의 참여자 결과 목록 (순번대로)
export default function RpsResultList({ joins }: Props) {
  if (joins.length === 0) {
    return (
      <p className="rounded-xl border border-dashed border-background-300 bg-background-50 px-5 py-8 text-center text-sm text-foreground-500">
        참여자가 없어 겨룰 상대가 없었습니다.
      </p>
    );
  }

  return (
    <ol className="space-y-2">
      {joins.map((j) => {
        const win = j.result === "W";
        return (
          <li
            key={j.pick}
            className={`flex items-center gap-3 rounded-xl border px-4 py-3 ${
              j.is_mine === 1
                ? "border-primary-300 bg-primary-50"
                : "border-background-200 bg-background-50"
            }`}
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 font-heading text-xs font-bold text-foreground-500">
              {j.pick}
            </span>
            <span className="w-9 shrink-0 text-center text-xl leading-none" aria-hidden="true">
              {handEmoji(j.hand)}
            </span>
            <span className="flex-1 text-sm text-foreground-800">
              <strong className={`${win ? "font-heading font-extrabold text-foreground-950" : "font-semibold"}`}>
                {handFull(j.hand, j.hand_txt)}
              </strong>
              <span className="mt-0.5 flex items-center gap-1.5 text-foreground-600">
                <Avatar name={j.name} photo={j.photo} size={20} />
                <span className="font-medium">
                  {j.aho} {j.name}
                </span>
                {j.is_mine === 1 && (
                  <span className="text-xs font-semibold text-primary-700">나</span>
                )}
              </span>
            </span>
            <span
              className={`shrink-0 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-bold ${resultBadge(
                j.result
              )}`}
            >
              {resultLabel(j.result, j.result_txt)}
            </span>
          </li>
        );
      })}
    </ol>
  );
}